(() => {
  const TRUSTED_CUSTOMIZER_ORIGIN = 'https://customandsnap.netlify.app';
  const root = document.getElementById('RaccoonieCustomizer');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';

  const modal = root.querySelector('.raccoonie-customizer__modal');
  const frame = root.querySelector('.raccoonie-customizer__frame');
  const launch = root.querySelector('.raccoonie-customizer__launch');
  const entry = root.querySelector('.raccoonie-customizer__entry');
  const status = root.querySelector('.raccoonie-customizer__status');
  const variantsScript = root.querySelector('[data-customizer-variants]');
  const variants = JSON.parse(variantsScript.textContent || '[]');
  const shopifyProductId = root.dataset.shopifyProductId;

  const paletteOptionNames = {
    'custom-clicker': {
      'milk-tea-pastel': 'Đỏ hồng',
      'matcha-cream': 'Xanh Matcha trắng',
      'cherry-cream': 'Kem đỏ',
      'black-white-classic': 'Đen trắng',
      'taro-sweet': 'Trắng tím',
      'orange-pop': 'Xanh mint cam',
      'honey-vanilla': 'Trắng vàng'
    },
    'round-clicker': {
      'orange-yellow': 'Cam - Vàng',
      'aqua-blue': 'Xanh Aqua - Xanh Blue',
      'red-pink': 'Đỏ - Hồng',
      'pink-purple': 'Hồng - Tím',
      'butter-purple': 'Xanh bơ - Tím',
      'black-white': 'Đen - Trắng',
      'matcha-white': 'Xanh Matcha - Trắng'
    }
  };

  function normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/đ/g, 'd')
      .replace(/Đ/g, 'D')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  function variantFor(payload) {
    const expectedColor = paletteOptionNames[payload.productSlug]?.[payload.colorPaletteId];
    const expectedLength = `khay ${payload.characterCount}`;

    return variants.find((variant) => {
      const options = variant.options || [variant.option1, variant.option2, variant.option3].filter(Boolean);
      const normalizedOptions = options.map(normalize);
      const lengthMatches = normalizedOptions.some((option) => option.startsWith(expectedLength));
      const colorMatches = !expectedColor || normalizedOptions.includes(normalize(expectedColor));
      return lengthMatches && colorMatches;
    });
  }

  function showStatus(message, isError) {
    status.textContent = message;
    status.style.background = isError ? '#b42318' : '#372c3d';
    status.hidden = false;
  }

  function openModal() {
    modal.hidden = false;
    document.documentElement.classList.add('raccoonie-customizer-open');
    if (!frame.src) frame.src = frame.dataset.src;
  }

  function closeModal() {
    modal.hidden = true;
    status.hidden = true;
    document.documentElement.classList.remove('raccoonie-customizer-open');
    launch.focus();
  }

  async function addToCart(payload) {
    if (payload.productSlug !== root.dataset.productSlug) {
      throw new Error('Sản phẩm custom không khớp với trang Shopify hiện tại.');
    }

    const variant = variantFor(payload);
    if (!variant) {
      throw new Error(`Không tìm thấy phiên bản ${payload.characterCount} ký tự cho màu đã chọn.`);
    }

    if (
      payload.version !== 2 ||
      !payload.mockup ||
      !payload.mockup.bytes ||
      payload.mockup.mimeType !== 'image/png'
    ) {
      throw new Error('Thiết kế chưa có ảnh mockup PNG. Hãy cập nhật lại trang custom.');
    }

    const properties = {
      'Tên custom': payload.displayName,
      'Số ký tự': String(payload.characterCount),
      'Bộ màu': payload.paletteName || payload.colorPaletteId,
      'Nội dung từng phím': payload.keyContents.join(' · '),
      '_Màu riêng từng phím': (payload.keyColors || []).join(' · '),
      '_Mã thiết kế': payload.designId,
      '_Dữ liệu thiết kế': JSON.stringify({
        version: payload.version,
        designId: payload.designId,
        productSlug: payload.productSlug,
        productName: payload.productName,
        characterCount: payload.characterCount,
        colorPaletteId: payload.colorPaletteId,
        paletteName: payload.paletteName,
        keyContents: payload.keyContents,
        keyColors: payload.keyColors,
        displayName: payload.displayName
      })
    };

    const imageBytes =
      payload.mockup.bytes instanceof ArrayBuffer
        ? payload.mockup.bytes
        : new Uint8Array(payload.mockup.bytes).buffer;
    const mockupFile = new File([imageBytes], payload.mockup.fileName, {
      type: payload.mockup.mimeType,
      lastModified: Date.now()
    });
    const formData = new FormData();
    formData.append('id', String(variant.id));
    formData.append('quantity', '1');
    Object.entries(properties).forEach(([name, value]) => {
      formData.append(`properties[${name}]`, value);
    });
    formData.append('properties[Ảnh mockup thiết kế]', mockupFile, mockupFile.name);

    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    });

    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || 'Không thể thêm vào giỏ hàng.');
    return result;
  }

  launch.addEventListener('click', openModal);
  root.querySelectorAll('[data-customizer-close]').forEach((button) => button.addEventListener('click', closeModal));
  frame.addEventListener('load', () => {
    const loading = root.querySelector('.raccoonie-customizer__loading');
    if (loading) loading.hidden = true;
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.hidden) closeModal();
  });

  window.addEventListener('message', async (event) => {
    if (event.origin !== TRUSTED_CUSTOMIZER_ORIGIN) return;
    if (event.source !== frame.contentWindow) return;
    if (event.data?.source !== 'raccoonie-customizer') return;
    if (event.data?.type !== 'RACCOONIE_CUSTOMIZER_COMPLETE') return;

    showStatus('Đang lưu ảnh mockup và thêm vào giỏ hàng…', false);
    try {
      const result = await addToCart(event.data.payload);
      closeModal();
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
      if (window.MinimogEvents && window.MinimogTheme?.pubSubEvents?.cartUpdate) {
        window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { cart: result });
      }
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Có lỗi xảy ra. Vui lòng thử lại.';
      showStatus(message, true);
      frame.contentWindow?.postMessage(
        {
          source: 'raccoonie-shopify',
          type: 'RACCOONIE_CUSTOMIZER_ADD_ERROR',
          message
        },
        TRUSTED_CUSTOMIZER_ORIGIN
      );
    }
  });

  const productFormWrapper =
    document.querySelector('.m-product-form--main .m-product-form--wrapper') ||
    document.querySelector('.m-product-form--wrapper');
  if (productFormWrapper) productFormWrapper.parentNode.insertBefore(entry, productFormWrapper);

  function hideNativePurchaseControls() {
    // Script này chỉ được Liquid nạp trên đúng 3 sản phẩm custom.
    // Vì vậy có thể ẩn trực tiếp toàn bộ khung mua hàng nằm cùng product-form
    // với nút custom mà không tác động tới sản phẩm khác.
    const mainProductForm = entry.closest('product-form');
    if (mainProductForm) {
      mainProductForm
        .querySelectorAll(
          '.m-product-form--wrapper, .m-add-to-cart, button[name="add"], ' +
          '.m-product-dynamic-checkout, .shopify-payment-button'
        )
        .forEach((element) => {
          element.hidden = true;
          element.setAttribute('aria-hidden', 'true');
          element.style.setProperty('display', 'none', 'important');
        });
    }

    const selectors = [
      `variant-picker[data-product-id="${shopifyProductId}"]`,
      `product-form[data-product-id="${shopifyProductId}"] .m-product-form--wrapper`,
      `product-form[data-product-id="${shopifyProductId}"] .m-add-to-cart`,
      `product-form[data-product-id="${shopifyProductId}"] .m-product-dynamic-checkout`,
      `product-form[data-product-id="${shopifyProductId}"] .shopify-payment-button`,
      `sticky-atc[data-product-id="${shopifyProductId}"]`
    ];

    selectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((element) => {
        const target = element.matches('sticky-atc')
          ? element.closest('.m-sticky-addtocart') || element
          : element;
        target.hidden = true;
        target.setAttribute('aria-hidden', 'true');
        target.style.setProperty('display', 'none', 'important');
      });
    });

    // Lớp dự phòng cho một số cấu hình theme tạo nút Shopify bên ngoài
    // product-form chính. Vẫn giới hạn trong trang của 3 sản phẩm custom.
    document
      .querySelectorAll(
        '.m-product-form--main .m-add-to-cart, ' +
        '.m-product-form--main button[name="add"], ' +
        '.m-product-form--main .m-product-dynamic-checkout, ' +
        '.m-product-form--main .shopify-payment-button'
      )
      .forEach((element) => {
        const target = element.closest('.m-product-form--wrapper') || element;
        target.hidden = true;
        target.setAttribute('aria-hidden', 'true');
        target.style.setProperty('display', 'none', 'important');
      });

    // Phương án cuối cùng không phụ thuộc HTML/class của theme:
    // tìm trực tiếp nút theo chữ đang hiển thị trong ảnh của shop.
    const nativeButtonLabels = new Set(['them vao gio hang', 'thanh toan']);
    const mainContent = document.getElementById('MainContent') || document.body;
    mainContent
      .querySelectorAll('button, a, [role="button"], input[type="submit"], .m-button')
      .forEach((element) => {
        if (element === launch || element.closest('#RaccoonieCustomizer')) return;
        const visibleLabel =
          element instanceof HTMLInputElement ? element.value : element.textContent;
        if (!nativeButtonLabels.has(normalize(visibleLabel))) return;

        const target =
          element.closest('.m-product-form--wrapper') ||
          element.closest('.shopify-payment-button') ||
          element.closest('.m-product-dynamic-checkout') ||
          element;
        target.hidden = true;
        target.setAttribute('aria-hidden', 'true');
        target.style.setProperty('display', 'none', 'important');
      });
  }

  hideNativePurchaseControls();
  const nativeControlsObserver = new MutationObserver(hideNativePurchaseControls);
  nativeControlsObserver.observe(document.getElementById('MainContent') || document.body, {
    childList: true,
    subtree: true
  });
})();
